export const vertexShader = /*glsl*/ `
varying vec2 vUv;

void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}`

export const fragmentShader = /*glsl*/ `
uniform float aspectRatio;
uniform vec3 color1;
uniform vec3 color2;
varying vec2 vUv;

void main() {
    // Adjust the uv coordinates based on the aspect ratio
    vec2 adjustedUV = vec2(vUv.x * aspectRatio, vUv.y * aspectRatio);
    
    // Calculate the distance from the center
    float distance = length(adjustedUV - vec2(0.5, 0.5) * aspectRatio);
    
    // Use the distance to mix between two colors
    vec3 color = mix(color1, color2, distance * 2.0); // Adjust the factor 2.0 as needed
    
    gl_FragColor = vec4(color, 1.0);
}`
